import React, { useRef, useContext } from 'react';
import PropTypes from 'prop-types';

import { ROLES } from '../../../../../constants/general.constants';
import { AdminUserDetailContext } from '../../AdminUserDetail';
import { Avatar, Card, Typography, EditBusinessUserProfileModal, EditTeacherProfileModal } from '../../../../components';
import * as S from './ProfileCard.styles';

const ProfileCard = ({ className }) => {
	const {
		state: { user },
		dispatch,
	} = useContext(AdminUserDetailContext);

	const modalRef = useRef(null);

	const handleCardButtonClick = () => {
		modalRef.current.open();
	};

	return user.role === ROLES.TEACHER ? (
		<Card className={className} title="Profile" transparentHeaderBorder={true} actions={[{ id: 1, label: 'Edit', size: 'small', variant: 'outline', icon: { source: ['fal', 'edit'] }, onClick: handleCardButtonClick }]}>
			<S.Wrapper>
				<div className="avatar-wrapper">
					<Avatar avatar={user?.profileImageObj?.[200]} />
				</div>
				<div className="info-wrapper">
					<div className="element-info">
						<Typography className="element-info__title" tag="h6" weight="semibold">
							Teacher UID
						</Typography>
						<Typography className="element-info__text" tag="p">
							{user?.uid}
						</Typography>
					</div>
					<div className="element-info">
						<Typography className="element-info__title" tag="h6" weight="semibold">
							Role
						</Typography>
						<Typography className="element-info__text" tag="p">
							{user?.teacherRole}
						</Typography>
					</div>
					<div className="element-info">
						<Typography className="element-info__title" tag="h6" weight="semibold">
							School
						</Typography>
						<Typography className="element-info__text" tag="p">
							{user?.primarySchool?.name}
						</Typography>
					</div>
				</div>
			</S.Wrapper>
			<EditTeacherProfileModal ref={modalRef} user={user} dispatch={dispatch} currentUser={false} allowedEditUID={true} />
		</Card>
	) : (
		<Card className={className} title="Profile" transparentHeaderBorder={true} actions={[{ id: 1, label: 'Edit', size: 'small', variant: 'outline', icon: { source: ['fal', 'edit'] }, onClick: handleCardButtonClick }]}>
			<S.Wrapper>
				<div className="avatar-wrapper">
					<Avatar avatar={user?.profileImageObj?.[200]} />
				</div>
				<div className="info-wrapper">
					<div className="element-info">
						<Typography className="element-info__title" tag="h6" weight="semibold">
							First Name
						</Typography>
						<Typography className="element-info__text" tag="p">
							{user?.firstName}
						</Typography>
					</div>
					<div className="element-info">
						<Typography className="element-info__title" tag="h6" weight="semibold">
							Last Name
						</Typography>
						<Typography className="element-info__text" tag="p">
							{user?.lastName}
						</Typography>
					</div>
					<div className="element-info">
						<Typography className="element-info__title" tag="h6" weight="semibold">
							Role
						</Typography>
						<Typography className="element-info__text capitalized" tag="p">
							{user?.businessPermissions?.[0] || 'Admin'}
						</Typography>
					</div>
				</div>
			</S.Wrapper>
			<EditBusinessUserProfileModal ref={modalRef} user={user} dispatch={dispatch} allowUpdatePermissions={true} currentUser={false} />
		</Card>
	);
};

ProfileCard.propTypes = {
	className: PropTypes.string,
};

export default ProfileCard;
